export default __webpack_public_path__ + "static/media/frame-example.a3044643.png";